import request from "../../utils/request";
import { Result } from "../../models/general";
import type { ProfileContactInput } from "../../models/publicProfile";

// Re-export the type for convenience
export type { ProfileContactInput } from "../../models/publicProfile";

/**
 * Submit contact information from a profile visitor.
 * This is an anonymous API call - no authentication required.
 * @param slug The profile slug
 * @param input The contact submission details
 * @returns Success result if the contact was submitted successfully
 */
export async function submitContact(slug: string, input: Omit<ProfileContactInput, 'profileSlug'>): Promise<Result<boolean>> {
    const response = await request.post<Result<boolean>>(
        `PublicProfile/p/${slug}/contact`,
        { ...input, profileSlug: slug },
        { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
}
